import CryptoJS from "crypto-js";

const DEFAULT_CREDENTIAL_SECRET = "cmf.remembered.user.v1";

const getCredentialSecret = () => {
    if (typeof window !== "undefined" && window.CREDENTIAL_ENCRYPTION_KEY) {
        return window.CREDENTIAL_ENCRYPTION_KEY;
    }

    return DEFAULT_CREDENTIAL_SECRET;
};

export const encryptCredential = (value) => {
    if (!value || typeof value !== "string") {
        return value;
    }

    try {
        return CryptoJS.AES.encrypt(value, getCredentialSecret()).toString();
    } catch (error) {
        return value;
    }
};

export const decryptCredential = (value) => {
    if (!value || typeof value !== "string") {
        return value;
    }

    try {
        const bytes = CryptoJS.AES.decrypt(value, getCredentialSecret());
        const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);

        // Backward compatibility: if it was plain text (legacy), keep original value.
        return decryptedValue || value;
    } catch (error) {
        return value;
    }
};
